import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {ExternalId} from "#template/nodes/types"
import {externalId} from "#template/nodes/validation"

export const idNodeParameters = z.object({id: externalId})
export type IdNodeParameters = {id: ExternalId}

export const isIdNode = (instance: unknown): instance is TemplateNode<IdNodeParameters> =>
    instance instanceof TemplateNode && idNodeParameters.safeParse(instance.parameters).success
